import { findDOMNode } from 'react-dom';
import * as React from 'react';

interface WTabsScrollbarProps extends React.ClassAttributes<any> {
    tabList: any;
}

interface WTabsScrollbarState {
    node: any;
    showScrollButtonLeft: boolean;
    showScrollButtonRight: boolean;
    tabsScrollPosition: number;
}

export class WTabsScrollbar extends React.Component<WTabsScrollbarProps, WTabsScrollbarState> {

    constructor(props: any) {
        super(props);
        this.state = {
            node: null,
            showScrollButtonLeft: false,
            showScrollButtonRight: false,
            tabsScrollPosition: 0
        };
        this.onUpdate = this.onUpdate.bind(this);
    }
    private hasScrollbar: boolean;
    private height: number;
    private left: number = 0;
    private style: any = {
        button: {
            color: 'white', backgroundColor: '#888', minWidth: 28, padding: 4, boxSizing: 'border-box', position: 'absolute', zIndex: 1,
            display: 'table', opacity: 0.5, userSelect: 'none'
        },
        span: { textAlign: 'center', verticalAlign: 'middle', display: 'table-cell' }
    };
    private scrollStep: number = 200;

    componentDidMount(): void {
        const node: any = findDOMNode(this.props.tabList);
        const offset: number = node.offsetWidth;
        const width: number = node.scrollWidth;
        this.hasScrollbar = !((node.style.overflowX || null) === 'hidden');
        this.height = this.style.button.height = node.clientHeight;
        this.style.button.cursor = this.hasScrollbar ? 'default' : 'pointer';
        window.addEventListener('resize', () => this.onUpdate);
        this.setState({ node, showScrollButtonRight: offset < width });
    }

    componentDidUpdate(): void {
        const node: any = findDOMNode(this.props.tabList);

        if (node.scrollLeft !== this.left) {
            this.setState({ node }, () => {
                this.onUpdate();
                this.left = node.scrollLeft;
            });
        }
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', () => this.onUpdate);
    }

    onUpdate(): void {
        const node: any = this.state.node;
        const left: number = node.scrollLeft;
        const offset: number = node.offsetWidth;
        const width: number = node.scrollWidth;
        this.setState({
            showScrollButtonLeft: left > 0,
            showScrollButtonRight: (offset + left) < width
        });
    }

    render(): JSX.Element {
        return (
            <>
                {this.state.showScrollButtonLeft && this.renderButtonScrollLeft()}
                {this.state.showScrollButtonRight && this.renderButtonScrollRight()}
            </>
        );
    }

    renderButtonScrollLeft(): JSX.Element {
        return (
            <div
                style={{ ...this.style.button, left: 0 }}
                onClick={() => {
                    if (this.hasScrollbar) {
                        return;
                    }
                    const node: any = this.state.node;
                    const left: number = node.scrollLeft;
                    const step: number = this.scrollStep;
                    let position: number = this.state.tabsScrollPosition;
                    position -= left < step ? left : step;
                    this.setState({ tabsScrollPosition: position }, () => {
                        node.scrollLeft = position;
                        this.onUpdate();
                    });
                }}
            >
                <span style={this.style.span}>&lang;</span>
            </div>
        );
    }

    renderButtonScrollRight(): JSX.Element {
        return (
            <div
                style={{ ...this.style.button, right: 0 }}
                onClick={() => {
                    if (this.hasScrollbar) {
                        return;
                    }
                    const node: any = this.state.node;
                    const left: number = node.scrollLeft;
                    const offset: number = node.offsetWidth;
                    const step: number = this.scrollStep;
                    const width: number = node.scrollWidth;
                    const diff: number = width - offset - left;
                    let position: number = this.state.tabsScrollPosition;
                    position += (offset + left + step) > width
                        ? (diff <= 0 ? 0 : diff)
                        : step;
                    this.setState({ tabsScrollPosition: position }, () => {
                        node.scrollLeft = position;
                        this.onUpdate();
                    });
                }}
            >
                <span style={this.style.span}>&rang;</span>
            </div>
        );
    }
}
